__webpack_require__.p = "/wp-content/themes/edc-newvison/dist/";